import { TOGGLE_SETTINGS, FILTER_SERVICE } from "./constants";

export const servicesSettingsToggle = () => {
  return {
    type: TOGGLE_SETTINGS
  };
};

//For filter simulation
export const filterService = () => (dispatch, getState) => {
  let data = getState().services.data;
  let min = 1;
  let max = data.length;
  let random = Math.floor(Math.random() * (+max - +min)) + +min;

  let filteredArray = data.slice(0, random);

  dispatch(_simulateFilter(filteredArray));
};

const _simulateFilter = arr => {
  return {
    type: FILTER_SERVICE,
    payload: arr
  };
};
